import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import { REQUEST_STATUS_COMPLETED } from '../../../../share/util/api/polling';
import { PHASE, EXECUTION_ROUTINE_RESULT_TYPE } from './constants';
import { stopSessionTransition } from './stop_session_transition';

/** 実行処理 
 * @param {instance} self 呼び出し元インスタンス
 */
export async function execute(self) {
  try {
    self.isLoading = true;

    // バックエンドAPI POST,GET
    const token = session.getToken();
    const executeResponse = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'execute'
      },
      // エラー発生のコールバックを実装
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
    );

    if (!executeResponse) return;
    
    self.isDispose = executeResponse.data.user_data.is_dispose;
    if (executeResponse.data.status === REQUEST_STATUS_COMPLETED) {
      //正常終了
      switch (executeResponse.data.user_data.result) {
        // GPF再生異常表示(冷却不要)へ遷移
        // 取得したvalueの値により文言を表示
        case EXECUTION_ROUTINE_RESULT_TYPE.ABNORMAL:
          await stopSessionTransition(self);
          self.gpfErrorTxt = `${self.i18nWsKey}.REQ_WS_158_TXT_14_${executeResponse.data.user_data.value}`;
          self.phase = PHASE.GPF_ERROR;
          break;
        // GPF再生状態確認(2回目以降)へ遷移
        case EXECUTION_ROUTINE_RESULT_TYPE.RETRY:
          self.phase = PHASE.EXECUTION_MONITORING_STATUS;
          await self.executeCheck();
          break;
        default:
          break;
      }
    } else {
      //異常終了 共通エラーへ遷移
      await self.showUnexpectedError();
      return;
    }
  } finally {
    self.isLoading = false;
  }
}
